import React from "react";

function ItemShopShimmer() {
    return (
        <div className="rounded-[12px] border-2 border-[#e4e5e7] overflow-hidden bg-white animate-pulse">

            {/* Image */}
            <div className="relative h-[120px] bg-[#f4f5f6]">
                <div className="absolute bottom-[8px] left-[8px] flex gap-[4px]">
                    <div className="h-[20px] w-[70px] rounded-[6px] bg-[#ececec]" />
                    <div className="h-[20px] w-[60px] rounded-[6px] bg-[#ececec]" />
                </div>
            </div>

            <div className="p-[16px] flex flex-col gap-[10px]">

                {/* Name + Rating */}
                <div className="flex items-center justify-between">
                    <div className="h-[18px] w-[140px] rounded bg-[#f4f5f6]" />
                    <div className="h-[14px] w-[40px] rounded bg-[#f4f5f6]" />
                </div>

                {/* Address */}
                <div className="flex items-center gap-[6px]">
                    <div className="w-[14px] h-[14px] rounded-full bg-[#f4f5f6]" />
                    <div className="h-[13px] w-[180px] rounded bg-[#f4f5f6]" />
                </div>

                {/* Hours */}
                <div className="flex items-center justify-between">
                    <div className="h-[13px] w-[120px] rounded bg-[#f4f5f6]" />
                    <div className="h-[13px] w-[40px] rounded bg-[#f4f5f6]" />
                </div>

                {/* Tags */}
                <div className="flex flex-wrap gap-[4px] mt-[4px]">
                    <div className="h-[22px] w-[80px] rounded-[6px] bg-[#f4f5f6]" />
                    <div className="h-[22px] w-[95px] rounded-[6px] bg-[#f4f5f6]" />
                    <div className="h-[22px] w-[65px] rounded-[6px] bg-[#f4f5f6]" />
                </div>

                {/* Description */}
                <div className="space-y-[6px] mt-[4px]">
                    <div className="h-[12px] w-full rounded bg-[#f4f5f6]" />
                    <div className="h-[12px] w-[95%] rounded bg-[#f4f5f6]" />
                    <div className="h-[12px] w-[70%] rounded bg-[#f4f5f6]" />
                </div>

                {/* More Info */}
                <div className="h-[14px] w-[70px] rounded bg-[#f4f5f6] mt-[4px]" />
            </div>

            {/* Bottom Buttons */}
            <div className="px-[16px] pb-[16px] pt-[4px] flex gap-[8px]">
                <div className="flex-1 h-[38px] rounded-[10px] bg-[#f4f5f6]" />
                <div className="flex-1 h-[38px] rounded-[10px] bg-[#f4f5f6]" />
            </div>
        </div>
    );
}

export default ItemShopShimmer;